export default "__VITE_ASSET__B4DJk4je__"